angular.module 'zc.projects'
.service 'titlesBySegmentType', ($filter) ->
  return {
    new: $filter('translate')('projectsSegments.titlesBySegmentType.hitsuji_kounyuu')
    all: $filter('translate')('projectsSegments.titlesBySegmentType.zentai')
    new_inverse: $filter('translate')('projectsSegments.titlesBySegmentType.hitsuji_kounyuu_igai')
    cv_users: $filter('translate')('projectsSegments.titlesBySegmentType.ikkai_ijou_kounyuu')
    inactive: $filter('translate')('projectsSegments.titlesBySegmentType.kyuumin_yuuzaa')
    custom: $filter('translate')('projectsSegments.titlesBySegmentType.tokushu')
    custom_old: $filter('translate')('projectsSegments.titlesBySegmentType.tokushu_nasegumento_kyuu')
  }



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.segments/titles_by_segment_type.coffee